import { RawLogicsMemory } from "../rawLogics/RawMemory";
import {
	LogicsData,
	LogicsVariable,
	fromRawData,
	fromRawVariables,
} from "./LogicsVariable";

export interface LogicsMemory {
	name: string;
	description: string;

	hexId: string;
	data?: LogicsData[];
	variables: LogicsVariable[];

	size: number;

	tags: string[];
	modifiers: Record<string, string | number | boolean>;
}

export function fromRawMemories(
	rawMemories: RawLogicsMemory[],
): LogicsMemory[] {
	return rawMemories.map(fromRawMemory);
}

function fromRawMemory(rawMemory: RawLogicsMemory): LogicsMemory {
	return {
		name: rawMemory.name,
		description: rawMemory.description,
		hexId: rawMemory.hexId,

		data: rawMemory.data?.map(fromRawData),
		variables: fromRawVariables(rawMemory.variables),

		size: rawMemory?.size ?? 36,

		tags: rawMemory.tags ?? [],
		modifiers: rawMemory.modifiers ?? {},
	};
}
